
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser } from '@signing-page/users/types/user';
import RecipientsTable from '@signing-page/recipients/components/RecipientsTable.vue';
import Sender from '@signing-page/recipients/components/Sender.vue';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { EModalSizes } from '@/enums/ModalSizes';
import Button from '@/components/Button.vue';
import { ESidebarOptionType } from '@signing-page/documents/types/enums/sidebar-option-type';
import { IDocument } from '@signing-page/documents/types/document';
import { EDocumentStatus } from '@signing-page/documents/types/enums/document-status';

@Component({
  components: {
    RecipientsTable,
    Sender,
    Button,
  },
})
export default class RecipientsModal extends Vue {
  @Prop() document!: IDocument;
  @Prop() company!: string;
  @Prop() sender!: IUser;
  @Prop() recipients!: IRecipient[];
  @Prop() isSigningOrder!: boolean;
  @Prop() isPreview: boolean;
  @Prop() currentRecipientsTurnToSign: boolean;
  @Prop() recipientsTurnToSign: IRecipient;

  EModalSizes = EModalSizes;

  handleClose() {
    this.$emit('close');
  }

  handleInvite() {
    this.handleClose();
    this.$emit('select', ESidebarOptionType.Invite);
  }

  get title(): string {
    return `${this.$t('recipients').toString()} (${this.recipients.length})`;
  }

  get showInviteButton(): boolean {
    if (this.isPreview) {
      return false;
    }
    return ![
      EDocumentStatus.Signed,
      EDocumentStatus.Recalled,
      EDocumentStatus.Rejected,
      EDocumentStatus.Lost,
    ].includes(this.document.status);
  }

  get signingOrderMessage(): string {
    if (!this.isSigningOrder) {
      return '';
    }

    if (this.currentRecipientsTurnToSign) {
      return this.$t('your-turn-to-sign').toString();
    }

    if (!this.recipientsTurnToSign) {
      return this.$t('other-turn-to-sign-hidden').toString();
    }

    return this.$t('other-turn-to-sign', { name: this.recipientsTurnToSign.fullName }).toString();
  }
}
